import { Text } from "@overmap-ai/blocks"
import { type IssueComment, type Stored, UNTITLED_ISSUE_TITLE } from "@overmap-ai/common"
import { selectIssueById, selectUserById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { interactiveTextCva } from "../../cva"
import { ProjectTimelineItemType } from "../../enums/projects"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { IssueTypeIcon } from "../Icons/IssueTypeIcon"
import { IssueIndexLabel } from "../IndexLabels/IssueIndex"
import { ProjectTimelineCard } from "./ProjectTimelineCard"

interface ProjectTimelineIssueCommentItemProps {
	issueComment: Stored<IssueComment>
}

export const ProjectTimelineIssueCommentItem = memo<ProjectTimelineIssueCommentItemProps>((props) => {
	const { issueComment } = props

	const user = useAppSelector(selectUserById(issueComment.created_by ?? -1))
	const issue = useAppSelector(selectIssueById(issueComment.issue))!

	return (
		<ProjectTimelineCard type={ProjectTimelineItemType.ISSUE_COMMENT}>
			<Text size="sm" accentColor="base" className="min-w-0">
				<Text highContrast>{getUserDisplayLabel(user)}</Text>
				&nbsp;commented on issue&nbsp;
				<Link
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/issues/$issueId"
					params={{ issueId: issue.uuid }}
				>
					<Text highContrast className={interactiveTextCva()}>
						<IssueTypeIcon className="align-sub" issueTypeId={issue.issue_type} />
						&nbsp;
						<IssueIndexLabel issueId={issue.uuid} highContrast />
						<Text accentColor="base">&nbsp;{issue.title || UNTITLED_ISSUE_TITLE}</Text>
					</Text>
				</Link>
				<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(issueComment.submitted_at)}</Text>
			</Text>
		</ProjectTimelineCard>
	)
})
ProjectTimelineIssueCommentItem.displayName = "ProjectTimelineIssueCommentItem"
